import {CustomerResponse} from '@aboutyou/grpc-clients/grips/protos/deprecated/customer.types';
import {TrackingCustomerData} from '@aboutyou/legacy-tracking-sdk';
import type {OptionalUserState} from '@aboutyou/user';

interface TrackingCustomerProps {
  user: OptionalUserState;
  customer: CustomerResponse | undefined;
  isLoggedIn: boolean;
}

export const getTrackingCustomer = ({
  user,
  customer,
  isLoggedIn,
}: TrackingCustomerProps): TrackingCustomerData => {
  if (!isLoggedIn || user.userData === null || !customer) {
    return {
      type: 'guest',
    };
  }

  return {
    type: user?.userData?.isExistingCustomer ? 'existing' : 'new',
    pc180Score: customer.pc180Score ?? null,
    id: user.userData.id,
    emh: user.userData.emailHash.emh,
    emhec: user.userData.emailHash.emhec,
    gender: user.userData.gender,
    vip: customer.isVIP,
    transactions: customer.transactions ?? null,
  };
};
